import React from 'react';
import './RelatorioCriticaPrint.css';

export default function RelatorioCriticaPrint({ inventario, loja, valorCorte, dadosCritica }) {
    const formatarMoeda = (val) => new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val || 0);

    return (
        <div className="relatorio-critica-container">
            {/* Cabeçalho de Marca */}
            <div className="brand-header">
                <img src={`${window.location.origin}/Images/arbor.png`} alt="ARBOR" className="brand-logo-img" />
                <div style={{ fontSize: '9pt', fontWeight: 'bold' }}>Módulo de Inventário Consinco</div>
            </div>

            {/* Cabeçalho Oficial do Relatório */}
            <div className="header-top">
                <div>
                    <h1 className="relatorio-titulo">Crítica do Inventário</h1>
                    <div style={{ marginTop: '4px' }}>
                        <strong>Inventário:</strong> {inventario?.numinv} &nbsp;&nbsp;&nbsp;
                        <strong>Descrição:</strong> {inventario?.descricao || 'INV. DE ITENS'}
                    </div>
                </div>
                <div className="header-corte-badge">
                    <span>{formatarMoeda(valorCorte)}</span>
                </div>
            </div>

            {/* Tabela de Produtos e Leituras de Lotes */}
            <table className="relatorio-table">
                <thead>
                    <tr>
                        <th style={{ width: '8%' }}>Código</th>
                        <th style={{ width: '16%' }}>EAN</th>
                        <th>Descrição</th>
                        <th style={{ width: '5%', textAlign: 'center' }}>Emb.</th>
                        <th style={{ width: '8%', textAlign: 'right' }}>Custo</th>
                        <th style={{ width: '10%', textAlign: 'right' }}>Diferença</th>
                        <th style={{ width: '8%', textAlign: 'right' }}>Coletado</th>
                        <th style={{ width: '6%', textAlign: 'center' }}>Check</th>
                    </tr>
                </thead>
                <tbody>
                    {dadosCritica && dadosCritica.map((prod, idx) => (
                        <React.Fragment key={idx}>
                            <tr className="row-produto">
                                <td className="fw-bold">{prod.codigo}</td>
                                <td>{prod.ean || ''}</td>
                                <td>{prod.descricao}</td>
                                <td style={{ textAlign: 'center' }}>{prod.emb || '1'}</td>
                                <td style={{ textAlign: 'right' }}>{formatarMoeda(prod.custo)}</td>
                                <td style={{ textAlign: 'right' }} className="fw-bold">
                                    {formatarMoeda(prod.divergencia_valor)}
                                </td>
                                <td style={{ textAlign: 'right' }}>{prod.qtd_contada || 0}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <div className="check-box"></div>
                                </td>
                            </tr>

                            {/* Detalhamento dos Lotes Coletados Abaixo do Produto */}
                            {prod.lotes_coletados && prod.lotes_coletados.length > 0 && (
                                <tr className="row-lotes-detalhe">
                                    <td colSpan={8} className="cell-lotes">
                                        <div className="lotes-grid">
                                            {prod.lotes_coletados.map((lt, lIdx) => (
                                                <span key={lIdx} className="lote-item">
                                                    <strong>Lote:</strong> {lt.inv_lote}&nbsp;&nbsp;
                                                    <strong>Seq:</strong> {lt.inv_seq}&nbsp;&nbsp;
                                                    <strong>Qtd:</strong> <u>{lt.inv_qtde}</u>
                                                </span>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>

            {/* Rodapé Fixo */}
            <div className="relatorio-footer">
                <div className="footer-line"></div>
                <div className="footer-info">
                    <div>Loja: {loja} | Inventário: {inventario?.numinv}</div>
                    <div>Matrícula Conferente: ____________________________________</div>
                    
                </div>
            </div>
        </div>
    );
}